import script from "./CorporateMemberNavbarItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./CorporateMemberNavbarItems.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__